import './source_view.js.coffee'
Namespace 'Settings.Views.Topics'

class Settings.Views.Topics.ExternalStreamSourceView extends Settings.Views.Topics.SourceView
  id: 'new_external_stream_source'
  icon: image_path('source_stream.png')
  channelViewClass: Settings.Views.Topics.ExternalStreamChannelView
  template: JST['backbone/templates/settings/topics/external_stream_source']

  events:
    'click .create-source': 'createSource'
    'click #new_external_stream_source': 'initialCheck'
    'change keyup keydown #input_name': 'checkName'
    'keyup #input_name': 'checkName'
    'keydown #input_name': 'checkName'

  initialize: ({sourceListEl, newSourceButtonsEl}) ->
    @sourceListEl = sourceListEl
    @newSourceButtonsEl = newSourceButtonsEl

  render: ->
    @$el.html @template
      sourceIcon: @icon
    @textbox = @$el.find('[name=name]')
    @aceptbutton = @$el.find('.create-source')
    @

  hasText: ->
    @textbox.val().length > 0

  checkName: ->
    if(@hasText())
      @aceptbutton.fadeIn()
    else
      @aceptbutton.fadeOut()

  initialCheck: ->
    @textbox.val('')
    @checkName()

  createSource: ->
    nameInput = @$el.find('.channel_fields #input_name').val()
    @$el.addClass('hidden')
    @channelView.remove() if @channelView
    @channelView = new @channelViewClass
      sourceIndex: '__index__'
      nameInput: nameInput
      allowRemove: true
    @sourceListEl.prepend(@channelView.render().el)
    @showAndDisableNewSourceButtons()
